module.exports = __webpack_public_path__ + "static/media/pic01.d0098c1b.webp";